// extracted by mini-css-extract-plugin
export default {"nav-icon":"Chat_nav-icon__MfZP0","loading-value":"Chat_loading-value__PY6pX"};